<template>
  <label class="checkbox" :class="[{ 'disabled': disabled }, { 'checked': checked.includes(value) }]" :style="masterStyle" v-if="Array.isArray(checked)">
    <i class="icon icon-check checkmark" v-if="checked.includes(value)"></i>
    <input class="checkbox" type="checkbox" :checked="checked.includes(value)" :value="value" @change="click" :disabled="disabled" />
  </label>

  <label class="checkbox" :class="[{ 'disabled': disabled }, { 'checked': checked }]" :style="masterStyle" v-else>
    <i class="icon icon-selected text-light1" :style="iconStyle" v-if="checked"></i>
    <input class="controller" type="checkbox" v-model="val" :value="value" @change="toggle" :disabled="disabled" />
  </label>
  
</template>

<script>
export default {
  name: "Checkbox",
  model: {
    prop: "checked",
    event: "input"
  },
  props: {
    checked: [Array, Boolean],
    value: [Object, String, Number, Boolean, Array],
    locked: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String],
      default: 16
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: false
    };
  },
  computed: {
    toggleClass() {
      return this.val ? "on" : "off";
    },
    masterStyle() {
      return {
        width: (this.sizeNum) + this.sizeUnit,
        height: (this.sizeNum) + this.sizeUnit,
        borderWidth: Math.pow(this.sizeNum/2, (1/3)) + this.sizeUnit
      }
    },
    sizeNum() {
      if (typeof this.size == "number") {
        return this.size;
      }
      let size = this.size;
      const parts = size.split(/([a-zA-Z%]+)/);
      return Number(parts[0]) || 16;
    },
    sizeUnit() {
      if (typeof this.size == "number") {
        return "px";
      }
      let size = this.size;
      const parts = size.split(/([a-zA-Z%]+)/);
      return parts[1] || "px";
    },
    iconStyle() {
      return {
        fontSize: (this.sizeNum*5/8) + this.sizeUnit
      }
    }
  },
  watch: {
    checked(newV) {
      if (this.val != newV) this.val = newV;
    }
  },
  created() {
    this.val = this.checked;
  },
  methods: {
    toggle() {
      this.$emit("input", this.val);
    },
    click() {
      if (this.disabled) {
        return;
      }
      if (this.checked.includes(this.value)) {
        this.checked.splice(this.checked.indexOf(this.value), 1);
      } else {
        this.checked.push(this.value);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkbox {
  border-style: solid;
  border-color: $textLightModeDisabled;
  border-radius: $radius;
  @include flex-center;
  cursor: pointer;
  @include trans-all;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  &:hover {
    border-color: $textLightModeLow;
    background-color: $textDarkModeHigh;
  }
  &.checked {
    background: $mono3;
    border-color: $mono3;
  }
}
</style>
